import React, { useCallback } from 'react';

import { faX } from '@fortawesome/pro-regular-svg-icons';

import { Icon } from 'js/components';
import { useSelectorContext } from './SelectorContext';

import styles from './CapabilitySelector.module.scss';

function SelectedCapabilityTag({ depth = 0, capability, idField = 'id' }) {
  const { deselectCapability } = useSelectorContext();

  const handleRemove = useCallback(() => {
    deselectCapability(capability);
  }, [deselectCapability, capability]);

  return (
    <div className={`${styles.tag} palette-cat-${depth + 1}`}>
      <span className={styles['tag-name']}>{capability.name}</span>
      <button onClick={handleRemove}>
        <Icon icon={faX} transform="shrink-3" />
      </button>
    </div>
  );
}

export default SelectedCapabilityTag;
